import React from 'react'
import e from "./img/err.gif";

const Error = () => {

  
  return (
    <>
    <div className='err-bg'><img className='err-img' src={e}/></div>
    </>
  )
}

export default Error